export default [
    {
        path: '',
        query: true,
        component: () => import('../views/drivers/Candidate/index'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-candidates',
            title: 'Кандидаты'
        },
        children: [{
            path: '/(uk/|ru/)?/candidates/index',
            name: 'Candidate',
            query: true,
            component: () => import('../views/drivers/Candidate/modules/list'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-candidates',
                title: 'Кандидаты'
            },
        }, {
            path: '/(uk/|ru/)?/candidates/finished',
            name: 'CandidateListFinished',
            query: true,
            component: () => import('../views/drivers/Candidate/modules/finished'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-candidates',
                title: 'Кандидаты'
            },
        }]
    }, {
        path: '/(uk/|ru/)?/drivers/candidates/edit',
        name: 'CandidateEdit',
        component: () => import('../views/drivers/Candidate/Edit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-candidates',
            title: 'Редактирвоание кандидата'
        },
    }, {
        path: '/(uk/|ru/)?/drivers/candidates/view',
        name: 'LeadView',
        component: () => import('../views/drivers/Candidate/LeadView'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-candidates',
            title: 'Просмотр кандидата'
        },
    },
]
